import TeamsContainer from './containers/TeamsContainer';

export default TeamsContainer;
